/**
 * @file debug.js
 * @module debug
 * @description
 * A simple utility for managing debug mode in the browser using `localStorage`.
 * It provides methods to enable, disable, check, and initialize debug mode.
 *
 * The debug state is stored under the key `'ecux_debug_enabled'` in `localStorage`.
 * When enabled, debug messages are logged to the console.
 *
 * @example
 * const debug = require('./debug');
 * debug.enableDebug(); // Enables debug mode
 * debug.disableDebug(); // Disables debug mode
 * debug.init(); // Logs if debug mode is active
 *
 * @exports debug
 * @namespace
 * @property {function(): boolean} isDebugEnabled - Returns `true` if debug mode is enabled.
 * @property {function(): void} enableDebug - Enables debug mode and logs a message.
 * @property {function(): void} disableDebug - Disables debug mode and logs a message.
 * @property {function(): void} init - Initializes the debug utility and logs if debug mode is active.
 */
const STORAGE_KEY = 'ecux_debug_enabled';
const debug = {
  isDebugEnabled: function () {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  },

  enableDebug: function () {
    localStorage.setItem(STORAGE_KEY, 'true');
    console.info('[ECUX] Debug mode enabled');
  },

  disableDebug: function () {
    localStorage.setItem(STORAGE_KEY, 'false');
    console.info('[ECUX] Debug mode disabled');
  },

  init: function() {
    if (debug.isDebugEnabled()) {
        console.info('[ECUX] Debug mode is active');
    }
  }
};

module.exports = debug;
